export const auti = [
    {
        id: 1,
        slike: [
            "auti/1/1_1.png",
            "auti/1/1_2.png",
            "auti/1/1_3.png",
        ],
        vozilo: "Volkswagen golf VIII GTI 245KS",
        opis: [
            "STAGE 1",
            "Optimizacija mjenjača",
            "245KS > 327KS",
        ],
    },
    {
        id: 2,
        slike: [
            "auti/2/2_1.png",
            "auti/2/2_2.png",
            "auti/2/2_3.png",
        ],
        vozilo: "Audi RS6 C7 4.0 TFSI V8 560ks 2014",
        opis: [
            "Vmax off",
            "Decat",
            "STAGE 1",
            "560ks > 650ks",
        ],
    },
    {
        id: 3,
        slike: [
            "auti/3/3_1.png",
            "auti/3/3_2.png",
            "auti/3/3_3.png",
        ],
        vozilo: "Audi A4 Quattro 2.0 TDI 190ks 2016",
        opis: [
            "Vmax off",
            "STAGE 1",
            "190ks > 225ks",
        ],
    },
    {
        id: 4,
        slike: [
            "auti/4/4_1.png",
            "auti/4/4_2.png",
        ],
        vozilo: "VW Polo 2.0 GTI DSG 2020 203ks",
        opis: [
            "Vmax off",
            "STAGE 1+",
            "203ks > 260ks",
        ],
    },
    {
        id: 5,
        slike: [
            "auti/5/5_1.png",
            "auti/5/5_2.png",
        ],
        vozilo: "VW PHEATON 3.0 TDI V6 2004",
        opis: [
            "DPF off",
            "EGR Off",
        ],
    },
    {
        id: 6,
        slike: [
            "auti/6/6_1.png",
            "auti/6/6_2.png",
        ],
        vozilo: "Mercedes C180d 2017",
        opis: [
            "ADBLUE off",
        ],
    },
    {
        id: 7,
        slike: [
            "auti/7/7_1.png",
            "auti/7/7_2.png",
        ],
        vozilo: "LAND ROVER",
        opis: [
            "DPF off",
            "EGR off",
            "ADBLUE off",
        ],
    },
    {
        id: 8,
        slike: [
            "auti/8/8_1.png",
            "auti/8/8_2.png",
        ],
        vozilo: "PEUGEOT 3008 2.0 HDI 105ks 2017",
        opis: [
            "ADBLUE off",
        ],
    },
    {
        id: 9,
        slike: [
            "auti/9/9_1.png",
            "auti/9/9_2.png",
            "auti/9/9_3.png",
        ],
        vozilo: "Audi A4 2.0 TDI 163ks 2015",
        opis: [
            "Vmax off",
            "EGR off",
            "DPF off",
            "ADBLUE off",
            "STAGE 1+",
            "163ks > 215ks",
        ],
    },
    {
        id: 10,
        slike: [
            "auti/10/10_1.png",
            "auti/10/10_2.png",
            "auti/10/10_3.png",
        ],
        vozilo: "Mercedes GLC 220d",
        opis: [
            "Vmax off",
            "STAGE 1",
        ],
    },
    {
        id: 11,
        slike: [
            "auti/11/11_1.png",
            "auti/11/11_2.png",
            "auti/11/11_3.png",
        ],
        vozilo: "Audi A3 S-Line 2.0 TDI 150ks 2019",
        opis: [
            "Vmax off",
            "STAGE 1",
            "150ks > 190ks",
        ],
    },
    {
        id: 12,
        slike: [
            "auti/12/12_1.png",
            "auti/12/12_2.png",
            "auti/12/12_3.png",
        ],
        vozilo: "Škoda Octavia 2.0 TDI 140ks 2012",
        opis: [
            "Update sofvera",
            "EGR off",
        ],
    },
    {
        id: 13,
        slike: [
            "auti/13/13_1.png",
            "auti/13/13_2.png",
            "auti/13/13_3.png",
        ],
        vozilo: "VW Arteon R-Line 2.0 TDI 190ks 2019",
        opis: [
            "Vmax off",
            "STAGE 1",
            "190ks > 220ks",
        ],
    },
    {
        id: 14,
        slike: [
            "auti/14/14_1.png",
            "auti/14/14_2.png",
        ],
        vozilo: "Citroen C4 1.6 HDI 92ks 2015",
        opis: [
            "Vmax off",
            "STAGE 1",
            "92ks > 120ks",
        ],
    },
    {
        id: 15,
        slike: [
            "auti/15/15_1.png",
            "auti/15/15_2.png",
        ],
        vozilo: "VW Caddy 1.9 TDI 105ks 2006",
        opis: [
            "EGR off",
            "Vmax off",
            "STAGE 1",
            "105ks > 140ks",
        ],
    },
    {
        id: 16,
        slike: [
            "auti/16/16_1.png",
            "auti/16/16_2.png",
            "auti/16/16_3.png",
        ],
        vozilo: "Alfa Mito 1.3 JTDM 90ks 2009",
        opis: [
            "DPF off",
            "EGR off",
        ],
    },
    {
        id: 17,
        slike: [
            "auti/17/17_1.png",
            "auti/17/17_2.png",
            "auti/17/17_3.png",
        ],
        vozilo: "Audi A5 S-Line 2.0 TDI 190ks 2016",
        opis: [
            "ADBLUE off",
            "DPF off",
            "EGR off",
            "STAGE 2",
            "190ks > 240ks",
        ],
    },
    {
        id: 18,
        slike: [
            "auti/18/18_1.png",
            "auti/18/18_2.png",
        ],
        vozilo: "BMW 420D 2015",
        opis: [
            "Kodiranje US Style žmigavci dnevno svijetlo",
        ],
    },
    {
        id: 19,
        slike: [
            "auti/19/19_1.png",
            "auti/19/19_2.png",
            "auti/19/19_3.png",
        ],
        vozilo: "Mercedes Vito 111 1.6D 115ks 2017",
        opis: [
            "Ugradnja Android radia",
            "Stražnja kamera i senzori",
            "Vmax off",
            "STAGE 1",
            "115ks > 145ks",
        ],
    },
    {
        id: 20,
        slike: [
            "auti/20/20_1.png",
            "auti/20/20_2.png",
            "auti/20/20_3.png",
        ],
        vozilo: "VW Golf 7 1.6 TDI 110ks 2015",
        opis: [
            "Lambda sonda off",
        ],
    },
];